import { render } from "./WeiboPost.vue?vue&type=template&id=5cc40f82&scoped=true"
import script from "./WeiboPost.vue?vue&type=script&lang=js"
export * from "./WeiboPost.vue?vue&type=script&lang=js"

import "./WeiboPost.vue?vue&type=style&index=0&id=5cc40f82&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc40f82"]])

export default __exports__